export const GET_TEMPLATES = 'customerBackend/mail/abtest/GET_TEMPLATES';
export const CREATE_NEW_ROW = 'customerBackend/mail/abtest/CREATE_NEW_ROW';
export const UPDATE_ROW = 'customerBackend/mail/abtest/UPDATE_ROW';
export const START_TEST = 'customerBackend/mail/abtest/START_TEST';

export interface ABTestDistribution {
  value?: string | number;
  weight?: string | number;
}

export type ABTestShopId = string | number;

export interface ABTestRow {
  name: string;
  distributions: ABTestDistribution[];
  shops?: ABTestShopId[];
}

type EmptyAction = Record<string, never>;

export const getTemplates = () => ({
  type: GET_TEMPLATES,
  meta: {
    type: 'api',
    url: `abtests`,
    method: 'get',
  },
});

export const updateRow = (row: ABTestRow) => ({
  type: UPDATE_ROW,
  meta: {
    type: 'api',
    url: `abtests/${row.name}`,
    method: 'put',
    data: row,
  },
});


export const startTest = (name: string) => ({
  type: START_TEST,
  meta: {
    type: 'api',
    url: `abtests/${name}/start`,
    method: 'put',
  },
});


export const createNewRow = (newName: string) => ({
  type: CREATE_NEW_ROW,
  newName,
});


export const saveNewVersion = (content: unknown): EmptyAction => {
  void content;
  return {};
};

export const updateMailTemplate = (
  content: unknown,
  templateId: string | number,
): EmptyAction => {
  void content;
  void templateId;
  return {};
};
